import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useOpenApi } from '@/common/providers/open-api-provider';

export function useFetchSmsUsage(companyId: string): {
    status: 'error' | 'success' | 'pending';
    usage: number | undefined;
    refetch: () => void;
} {
    const { openApi } = useOpenApi();
    const openApiRef = useRef(openApi);
    useEffect(() => {
        openApiRef.current = openApi;
    });

    const { status, data, refetch } = useQuery({
        queryKey: ['fetchSmsUsage', companyId],
        queryFn: () => {
            return openApiRef.current.companies
                .getSmsUsage(companyId)
                .then((response) => {
                    return response.data.data.creditsUsed;
                });
        }
    });

    return {
        status,
        usage: data,
        refetch: () => {
            void refetch();
        }
    };
}

/**
 * Fetches authoritative subscription usage from the server (licensed users for
 * the app subscription; devices with fall/tilt/geofence effectively enabled for
 * the LWD subscription), rather than counting users/devices on the client.
 */
